import Axios from '@/api/http'
/**
 * 第三方签章
 * */
// 获取文件哈希
export function getSha (data) {
  return Axios({
    method: 'post',
    url: '/api/sha',
    data: data
  })
}
// 签证文件修改接口
export function updateapprovingca (data) {
  return Axios({
    method: 'post',
    url: '/api/updateapprovingca',
    data: data
  })
}
// 查询签署模板信息
export function signtemplates (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/signtemplates',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 每次签章都需要先调用部署合同
export function beginsigndoc (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/beginsigndocbylink',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 批量发起部署合同
export function beginlistsigndocbylink (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/beginlistsigndocbylink',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 文件签署(指定位置)
export function signdocbyposition (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/signdocbyposition',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 批量文件签署(指定位置)
export function signlistdocbyposition (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/signlistdocbyposition',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 文件签署(关键字)
export function signdocbykeyword (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/signdocbykeyword',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 批量文件签署(关键字)
export function signlistdocbykeyword (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/signlistdocbykeyword',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 文件手动归档
export function archivedoc (data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/archivedoc',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 文件批量手动归档
export function archivedoclist(data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/archivedoclist',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
// 文件作废
export function refusesigndoc(data) {
  return Axios({
    method: 'post',
    url: '/api/v1/contract/refusesigndoc',
    data: jsonDataRes(data),
    baseURL: baseURL ()
  })
}
export function getsigncontracturl (data) {
  // 在线签，获取url
  return Axios({
    method: 'post',
    url: '/api/v1/sign/getsigncontracturl',
    data:  jsonDataRes(data),
    baseURL: baseURL ()
  })
}
export function docinfos (data) {
  // 查询文件信息
  return Axios({
    method: 'post',
    url: '/api/v1/contract/docinfos',
    data:  jsonDataRes(data),
    baseURL: baseURL ()
  })
}
export function dochashconf (data) {
  // 存证
  return Axios({
    method: 'post',
    url: '/api/v1/contract/dochashconf',
    data:  jsonDataRes(data),
    baseURL: baseURL ()
  })
}
export function downconfirmationbyid (data) {
  // 存证后电子确认函下载
  return Axios({
    method: 'post',
    url: '/api/v1/contract/downconfirmationbyid',
    data:  jsonDataRes(data),
    baseURL: baseURL ()
  })
}

export function setServerStamp (data) {
  // 新版设置服务器证书执行盖章操作 2023.4.3
  return Axios({
    method: 'post',
    url: '/service/api/setServerStamp',
    data: data,
    baseURL: baseURL ()
  })
}

export function setServerKeywordStamp (data) {
  // 新版设置服务器证书执行关键字盖章操作 2023.4.3
  return Axios({
    method: 'post',
    url: '/service/api/setServerKeywordStamp',
    data: data,
    baseURL: baseURL ()
  })
}

// ocr图片识别
export function ocrscan (data) {
  return Axios({
    method: 'post',
    url: '/openapi/ocrscan',
    data: data,
    baseURL: userURL ()
  })
}

// 获取百度AI token
export function getbdocrtoken (data) {
  return Axios({
    method: 'post',
    url: '/openapi/getbdocrtoken',
    data: data,
    baseURL: userURL ()
  })
}

// 获取百度AI token(政和部署的是内网，所以要修改ocr百度请求接口地址)
export function getUrlbdocrtoken (data, baseURL) {
  return Axios({
    method: 'post',
    url: '/openapi/getbdocrtoken',
    data: data,
    baseURL: baseURL
  })
}

// 获取OCR开关状态
export function getcompetencymanagelist (data) {
  return Axios({
    method: 'post',
    url: '/api/getcompetencymanagelist',
    data: data
  })
}

// 人脸检测
export function getfaceDetect (data) {
  return Axios({
    method: 'post',
    url: '/openapi/FaceDetect',
    data: data,
    baseURL: userURL ()
  })
}

// 人脸比对
export function arcsoftfacesearchs (data) {
  return Axios({
    method: 'post',
    url: '/openapi/arcsoftfacesearchs',
    data: data,
    baseURL: userURL ()
  })
}

// 新版人脸识别
export function facesearchs (data) {
  return Axios({
    method: 'post',
    url: '/api/facesearchs',
    data: data
  })
}

function jsonDataRes (data){
  return { jsonData: JSON.stringify({data: data})}
}
function baseURL () {
  return 'https://ca.topeti.com'
}
function userURL () {
  return 'https://user.topeti.com'
}